import { render, staticRenderFns } from "./PendingApprovalHint.vue?vue&type=template&id=ef3037c4&scoped=true"
import script from "./PendingApprovalHint.vue?vue&type=script&lang=js"
export * from "./PendingApprovalHint.vue?vue&type=script&lang=js"
import style0 from "./PendingApprovalHint.vue?vue&type=style&index=0&id=ef3037c4&prod&scoped=true&lang=css"
import style1 from "./PendingApprovalHint.vue?vue&type=style&index=1&id=ef3037c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3037c4",
  null
  
)

export default component.exports